import { ExternalCourseModelAPI } from 'models/externalCourse.model'
import api from '../..'
import { ExternalCoursesListParams } from './GetList'
import { buildQuery } from './utils'

const destroyMany = (
  ids: ExternalCourseModelAPI['id'][],
  allSelected: boolean,
  params?: ExternalCoursesListParams
) => {
  const q = buildQuery(params)
  return api.delete(`administration/multiple_external_courses`, {
    data: { ids, allSelected, q },
  })
}

export default destroyMany
